module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "paper_texture.20240897.png";